import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => {
  const { breakpoints, palette, spacing, border, radius } = theme;
  return {
    homeContainer: {
      backgroundColor: palette.background.main,
      minHeight: '1250px',
    },
    bodyContainer: {
      marginTop: `${spacing['5']}px`,
      maxWidth: '1400px',
      minHeight: '500px',
      margin: 'auto',
      [`@media screen and (min-width: ${breakpoints.md}px)`]: {
        marginTop: `${spacing['7']}px`,
      },
    },
    installedAppCard: {
      border: border.muted,
      borderRadius: `${radius.medium}px`,
      background: palette.background.light,
      padding: `${spacing['5']}px`,
    },
    installedAppCardTag: {
      width: '100%',
    },
  };
});

export default styles;
